import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IsFiltersOpenedStateService {

  private isFiltersOpened: EventEmitter<boolean> = new EventEmitter<boolean> ( false );

  constructor() { }

  public getFiltersCurrentStateEmitter( ): EventEmitter<boolean> {
    return this.isFiltersOpened ;
  }

  
}
